import { IconTokens, } from '@voltmoney/schema';
import Chat from './assets/Chat';
import Edit from './assets/Edit';
import Search from './assets/Search';
import Upload from './assets/Upload';
import Attachment from './assets/Attachment';
import Back from './assets/Back';
import PlusCircle from './assets/PlusCircle';
import Cross from './assets/Cross';
import ThreeDots from './assets/ThreeDots';
import LocationPin from './assets/LocationPin';
import RightArrow from './assets/RightArrow';
import DownArrow from './assets/DownArrow';
import Quotes from './assets/Quotes';
import Plus from './assets/Plus';
import InfoStatic from './assets/InfoStatic';
import Calendar from './assets/Calendar';
import Cake from './assets/Cake';
import BriefCase from './assets/BriefCase';
import Book from './assets/Book';
import Check2 from './assets/Check2';
import Shuffle from './assets/Shuffle';
import MinusCircle from './assets/MinusCircle';
import DoubleMessage from './assets/DoubleMessage';
import Info from './assets/Info';
import Lighting from './assets/Lighting';
import Notification from './assets/Notification';
import Play from './assets/Play';
import Download from './assets/Download';
import Mic from './assets/Mic';
import PDF from './assets/PDF';
import Gallery from './assets/Gallery';
import Video from './assets/Video';
import SendSolid from './assets/SendSolid';
import RightAngle from './assets/RightAngle';
import Fire from './assets/Fire';
import NewsPaper from './assets/NewsPaper';
import Share from './assets/Share';
import Google from './assets/Google';
import Messages from './assets/Messages';
import Star from './assets/Star';
import Sparkling from './assets/Sparkling';
import Bookmark from './assets/Bookmark';
import BookmarkFilled from './assets/BookmarkFilled';
import Page from './assets/Page';
import InfoFilled from './assets/InfoFilled';
import Sticker from './assets/Sticker';
import TwoUsers from './assets/TwoUsers';
import Check from './assets/Check';
import Dot from './assets/Dot';
import BulbFilled from './assets/BulbFilled';
import Warning from './assets/Warning';
import BulbOutline from './assets/BulbOutlne';
import CheckCircle from './assets/CheckCircle';
import Clock from './assets/Clock';
import Delete from './assets/Delete';
import AddUser from './assets/AddUser';
import UserClock from './assets/UserClock';
import Like from './assets/Like';
import LikeFilled from './assets/LikeFilled';
import Comment from './assets/Comment';
import StarOutline from './assets/StarOutline';
import Circle from './assets/Circle';
import Diamond from './assets/Diamond';
import Link from './assets/Link';
import Gift from './assets/Gift';
import CheckFilled from './assets/CheckFilled';
import InvertedComma from './assets/InvertedComma';
import CheckedSquare from './assets/CheckedSquare';
import Not_Checked_Square from './assets/Not_Checked_Square';
import Done from './assets/done';
import Email from './assets/Email';
import EmptyCircle from './assets/EmptyCircle';
import RadioCircleFilled from './assets/RadioCircleFilled';
import Group46 from './assets/Group46';
import SystemError from './assets/SystemError';
import Phone from './assets/Phone';
import CreditCard from './assets/CreditCard';
import Default from './assets/Default';
import Success from './assets/Success';
import Alert from './assets/Alert';
import Failed from './assets/Failed';
import InProgress from './assets/InProgress';
import Right from './assets/Right';
import ChevronDown from './assets/ChevronDown';
import InfoMessage from './assets/InfoMessage';
import Chart from './assets/Chart';
import RuppeFile from './assets/RuppeFile';
import Square from './assets/Square';
import GiftOutline from './assets/GiftOutline';
import InfoCropped from './assets/InfoCropped';
import Volt from './assets/Volt';
import Camera from './assets/Camera';
import ChervonDownRight from './assets/ChervonDownRight';
import CameraOff from './assets/CameraOff';
import SafeGuard from './assets/SafeGuard';
import Coin from './assets/Coin';
import Account from './assets/Account';
import Rectangle from './assets/Rectangle';
import Cancel from './assets/Cancel';
import Person from './assets/Person';
import Location from './assets/Location';
import Add from './assets/Add';
import Lock from './assets/Lock';
import Copy from './assets/Copy';
import GoogleSVG from './assets/GoogleSVG';
import OTPError from './assets/OTPError';
import DocFile from './assets/DocFile';
import Notebook from './assets/Notebook';
import ContractFile from './assets/ContractFile';
import FreeBook from './assets/FreeBook';
import Logout from './assets/Logout';
import Question from './assets/Question';
import HeadPhone from './assets/headPhone';
import User from './assets/User';
import Whatsapp from './assets/Whatsapp';
import Locked from './assets/Locked';
import ManageLimit from './assets/ManageLimit';
import Support from './assets/Support';
import File from './assets/File';
import VoltFull from './assets/VoltFull';
import Group74508 from './assets/Group74508';
import RadioCircleNotFilled from './assets/RadioCircleNotFilled';
import NOTSELCTEDCHART from './assets/Not_SelectedChart';
import TransactionNotSelected from './assets/Transaction_NotSelected';
import Sound from './assets/Sound';
import ChevronLeft from './assets/ChevronLeft';
import Cdsl from './assets/Cdsl';
import Powerby from './assets/Powerby';
import Cams from './assets/Cams';
import Kfin from './assets/Kfin';
import GreenClipBoard from './assets/GreenClipBoard';
import GreenRupee from './assets/GreenRupee';
import Telegram from './assets/Telegram';
import ThreeBar from './assets/ThreeBar';
import Nsdl from './assets/Nsdl';
import Bajaj from './assets/Bajaj';
import ThumpsUp from './assets/ThumpsUp';
import ShakeHands from './assets/ShakeHands';
import BellNotified from './assets/BellNotified';
import List from './assets/List';
import SvgChart from './assets/svgChart';
import Redirecting from './assets/Redirecting';
import FAQ from './assets/FAQ';
import ShieldRuppee from './assets/ShieldRuppee';
import EditBlue from './assets/EditBlue';
import UpsideArrow from './assets/UpsideArrow';
import ManageLimitSelected from './assets/ManageLimitSelected';
import SMS from './assets/SMS';
import OTPEmail from './assets/OTPEmail';
import GreenXls from './assets/GreenXls';
import CoveredRightArrow from './assets/CoveredRightArrow';
import ChevronUp from './assets/ChevronUp';
import SystemSuccess from './assets/SystemSuccess';
import Leads from './assets/Leads';
import GridView from './assets/GridView';
import NoNetwork from './assets/NoInternet';
import SuccessIcon from "./assets/SuccessIcon";
import Pending from "./assets/Pending";
import PendingRepay from './assets/PendingRepay';
import FailedNew from "./assets/FailedNew";
import AutoPayArrow from "./assets/AutoPayArrow";
import VoltPartner from "./assets/VoltPartner";
import GoldenThunder from "./assets/GoldenThunder";
import Brochure2 from "./assets/Brochure2";
import AddFriend2 from "./assets/addFriend2";
import Gift2 from "./assets/Gift2";
import Leads2 from "./assets/Leads2";
import ShareLink2 from "./assets/ShareLink2";
import Earning from "./assets/Earning";
import Collateral from "./assets/Collateral";
import DemoVideos from "./assets/DemoVideos";
import ProfileDetails from "./assets/ProfileDetails";
import BillingDetails from "./assets/BillingDetails";
import Faq2 from "./assets/Faq2";
import AboutUs2 from "./assets/AboutUs2";
import AboutUs from "./assets/AboutUs";
import TentoFiftyThousand from "./assets/TentoFiftyThousand";
import FiftyToTwoLakh from "./assets/FiftyToTwoLakh";
import TwoToTenLakh from "./assets/TwoToTenLakh";
import MoreThanTenLakh from "./assets/MoreThanTenLakh";
import NoMutualFund from "./assets/NoMutualFund";
import NoMutualFundDefault from "./assets/NoMutualFundDefault";
import NoMutualFundSelected from "./assets/NoMutualFundSelected";
import YesMutualFundDefault from "./assets/YesMutualFundDefault";
import YesMutualFundSelected from "./assets/YesMutualFundSelected";
import SliderIcon from "./assets/SliderIcon";
import AccountDetails from "./assets/AccountDetails";
import Lead3 from "./assets/Lead3";
import Customer3 from "./assets/customer3";
import Earning3 from "./assets/Earning3";
import Partner3 from "./assets/Partner3";
import Bijli from "./assets/Bijli";
import Megaphone from "./assets/megaphone";
import Share4 from "./assets/Share4";
import LinkedPartners from "./assets/LinkedPartnerts";
import VoltPlatform from "./assets/VoltPlatform";
import SuccessIcon1 from './assets/SuccessIcon1';
import VerifiedUser1 from "./assets/VerifiedUser1";
import CheckLimit1 from "./assets/CheckLimit1";
import CheckLimit_Grey from "./assets/CheckLimit_Grey";
import Meter1 from "./assets/Meter1";
import SystemWarning from "./assets/SystemWarning";
import PasswordHide from "./assets/PasswordHide";
import PasswordShow from "./assets/PasswordShow";
import RightBlueArrow from "./assets/RightBlueArrow";
import CrossIcon from "./assets/CrossIcon";
import ErrorIcon from "./assets/ErrorIcon";
import percentage from "./assets/Percentage";
import Debit from "./assets/Debit";
import Credit from "./assets/Credit";
import CreditTdl from "./assets/CreditTdl";
import DebitTdl from "./assets/DebitTdl";
import transactionSuccess from "./assets/transactionSuccess";
import transactionInProgress from "./assets/transactionInProgress";
import DigiLocker from "./assets/DigiLocker";
import InfoImage from "./assets/InfoImage";
import SecureIcon from "./assets/SecureIcon";
import Secure from "./assets/Secure";
import InfoIcon from "./assets/InfoIcon";
import chevronUp_V2 from "./assets/ChevronUp_V2";
import chevronDown_V2 from "./assets/ChevronDown_V2";
import Lender_Bajaj from "./assets/lender_Bajaj";
import Lender_Mirae from "./assets/lender_Mirae";
import Lender_Tata from "./assets/lender_Tata";
import greenPercentage1 from "./assets/greenPercentage1";
import greenClock1 from "./assets/greenClock1";
import greenRupee1 from "./assets/greenRupee1";
import Lender_Nuvama from "./assets/Lender_Nuvama";
import FlashComponent from "./assets/flash";
import Foreclosure from "./assets/Foreclosure";
import BackArrowIcon from "./assets/BackArrowIcon";
import Pan1 from "./assets/Pan1";
import Veridy_aadhaar_1 from "./assets/Veridy_aadhaar_1";
import SystemDelete from "./assets/SystemDelete";
import verifyAccountBank from "./assets/verifyAccountBank";
import UpiIcon from "./assets/UpiIcon";
import NetBanking from "./assets/NetBanking";
import UpBlackArrow from "./assets/UpBlackArrow";
import DownBlackArrow from "./assets/DownBlackArrow";
import UpiInProgress from "./assets/UpiInProgress";
import MailIcon from "./assets/MailIcon";
import CheckSms from './assets/CheckSMS';
import RightBlackIcon from './assets/RightBlackIcon';
import LeftBlackArrowIcon from "./assets/LeftBlackArrowIcon";
import SelectIcon from "./assets/SelectIcon";
import ShareIcon from "./assets/ShareIcon";
import AddPhoto from "./assets/AddPhoto";
import Filter from "./assets/Filter";
import UnSelectedRadioButton from "./assets/UnSelectedRadioButton";
import InProgressGrey from "./assets/InProgressGrey";
import APIFailureIcon from "./assets/APIFailureIcon";
import ContactHeadphones from "./assets/ContactHeadphones";
import VoltLogoNew from "./assets/VoltLogoNew";
import MessageOtp from "./assets/MessageOtp";
import Account_profile from "./assets/Account_profile";
import Logout_Profile from "./assets/Logout_Profile";
import AshokChakra from './assets/AshokChakra';
import IncomeTax from './assets/IncomeTax';
import ClockCheckLimit from "./assets/ClockCheckLimit";
import Illustration from "./assets/Illustration";
import CHECKED_ROUNDED_DLS from "./assets/CHECKED_ROUNDED_DLS";
import UNCHECK_ROUNDED_DLS from "./assets/UNCHECK_ROUNDED_DLS";
import CHECK_SQUARE_DLS from "./assets/CHECK_SQUARE_DLS";
import UNCHECK_SQUARE_DLS from "./assets/UNCHECK_SQUARE_DLS";
import SYSTEM_STATUS_ERROR_DLS from "./assets/SYSTEM_STATUS_ERROR_DLS";
import SYSTEM_STATUS_WARNING_DLS from "./assets/SYSTEM_STATUS_WARNING_DLS";
import SYSTEM_STATUS_SUCCESS_DLS from "./assets/SYSTEM_STATUS_SUCCESS_DLS";
import SYSTEM_STATUS_INFO_DLS from "./assets/SYSTEM_STATUS_INFO_DLS";
import SYSTEM_STATUS_INFO_REDBG_DLS from './assets/SYSTEM_STATUS_INFO_REDBG_DLS';
import SYSTEM_SUCCESS_DLS from "./assets/SYSTEM_SUCCESS_DLS";
import SYSTEM_CHEVRON_DOWN_DLS from "./assets/SYSTEM_CHEVRON_DOWN_DLS";
import SYSTEM_ERROR_DLS from "./assets/SYSTEM_ERROR_DLS";
import SYSTEM_MAIL_DLS from "./assets/SYSTEM_MAIL_DLS";
import SYSTEM_CALL_DLS from "./assets/SYSTEM_CALL_DLS";
import SYSTEM_CLOSE_W_CIRCLE_DLS from "./assets/SYSTEM_CLOSE_W_CIRCLE_DLS";
import SYSTEM_CANCEL_DLS from "./assets/SYSTEM_CANCEL_DLS";
import SYSTEM_EDIT_DLS from "./assets/SYSTEM_EDIT_DLS";
import SYSTEM_PAN_CARD_DLS from "./assets/SYSTEM_PAN_CARD_DLS";
import SYSTEM_BANK_DLS from "./assets/SYSTEM_BANK_DLS";
import SYSTEM_SEARCH_DLS from "./assets/SYSTEM_SEARCH_DLS";
import SYSTEM_ADD_DLS from "./assets/SYSTEM_ADD_DLS";
import SYSTEM_UNLOCK_DLS from "./assets/SYSTEM_UNLOCK_DLS";
import SYSTEM_INFO_DLS from "./assets/SYSTEM_INFO_DLS";
import SYSTEM_FILTER_DLS from "./assets/SYSTEM_FILTER_DLS";
import SYSTEM_BACK_DLS from "./assets/SYSTEM_BACK_DLS";
import SYSTEM_PERSON_DLS from "./assets/SYSTEM_PERSON_DLS";
import SYSTEM_LOCATION_DLS from "./assets/SYSTEM_LOCATION_DLS";
import SYSTEM_CALENDAR_DLS from "./assets/SYSTEM_CALENDAR_DLS";
import SYSTEM_DONE_DLS from "./assets/SYSTEM_DONE_DLS";
import SYSTEM_SHARE_DLS from "./assets/SYSTEM_SHARE_DLS";
import SYSTEM_NOTIFICATIONS_DLS from "./assets/SYSTEM_NOTIFICATIONS_DLS";
import SYSTEM_NOTIFICATIONS_ACTIVE_DLS from "./assets/SYSTEM_NOTIFICATIONS_ACTIVE_DLS";
import SYSTEM_EARLY_NUDGE_DLS from "./assets/SYSTEM_EARLY_NUDGE_DLS";
import SYSTEM_LATER_NUDGE_DLS from "./assets/SYSTEM_LATER_NUDGE_DLS";
import SYSTEM_COPY_DLS from "./assets/SYSTEM_COPY_DLS";
import SYSTEM_SKIP_DLS from "./assets/SYSTEM_SKIP_DLS";
import SYSTEM_CREDIT_DLS from "./assets/SYSTEM_CREDIT_DLS";
import SYSTEM_DEBIT_DLS from './assets/SYSTEM_DEBIT_DLS';
import SYSTEM_FAQ_DLS from "./assets/SYSTEM_FAQ_DLS";
import SYSTEM_SUPPORT_DLS from "./assets/SYSTEM_SUPPORT_DLS";
import SYSTEM_TERMS_DLS from "./assets/SYSTEM_TERMS_DLS";
import SYSTEM_POLICY_DLS from "./assets/SYSTEM_POLICY_DLS";
import SYSTEM_LOGOUT_DLS from "./assets/SYSTEM_LOGOUT_DLS";
import SYSTEM_MESSAGE_DLS from "./assets/SYSTEM_MESSAGE_DLS";
import SYSTEM_FAQ_V2_DLS from "./assets/SYSTEM_FAQ_V2_DLS";
import SYSTEM_RUPEE_DLS from "./assets/SYSTEM_RUPEE_DLS";
import SYSTEM_LINK_DLS from "./assets/SYSTEM_LINK_DLS";
import SYSTEM_INVESTOR_DLS from "./assets/SYSTEM_INVESTOR_DLS";
import SYSTEM_PARTNER_DLS from "./assets/SYSTEM_PARTNER_DLS";
import SYSTEM_WHATSAPP_DLS from "./assets/SYSTEM_WHATSAPP_DLS";
import SYSTEM_TELEGRAM_DLS from "./assets/SYSTEM_TELEGRAM_DLS";
import SYSTEM_MENU_DLS from "./assets/SYSTEM_MENU_DLS";
import SYSTEM_SORT_DLS from "./assets/SYSTEM_SORT_DLS";
import SYSTEM_EYE_DLS from "./assets/SYSTEM_EYE_DLS";
import SYSTEM_EYE_HIDE_DLS from "./assets/SYSTEM_EYE_HIDE_DLS";
import SYSTEM_DELETE_DLS from "./assets/SYSTEM_DELETE_DLS";
import SYSTEM_CHEVRON_RIGHT_DLS from "./assets/SYSTEM_CHEVRON_RIGHT_DLS";
import SYSTEM_CHEVRON_LEFT_DLS from "./assets/SYSTEM_CHEVRON_LEFT_DLS";
import SYSTEM_AADHAR_DLS from "./assets/SYSTEM_AADHAR_DLS";
import SYSTEM_PAN_V2_DLS from "./assets/SYSTEM_PAN_V2_DLS";
import SYSTEM_LOAN_FORECLOSURE_DLS from "./assets/SYSTEM_LOAN_FORECLOSURE_DLS";
import SYSTEM_LOAN_DLS from "./assets/SYSTEM_LOAN_DLS";
import SYSTEM_DOWNLOAD_DOC_DLS from "./assets/SYSTEM_DOWNLOAD_DOC_DLS";
import SYSTEM_REDIRECT_DLS from "./assets/SYSTEM_REDIRECT_DLS";
import SYSTEM_CHEVRON_UP_DLS from "./assets/SYSTEM_CHEVRON_UP_DLS";
import SYSTEM_ILLUSTRATION_DONE_DLS from "./assets/SYSTEM_ILLUSTRATION_DONE_DLS";
import SYSTEM_ILLUSTRATION_ERROR_DLS from "./assets/SYSTEM_ILLUSTRATION_ERROR_DLS";
import SYSTEM_ILLUSTRATION_CLEAR_DLS from "./assets/SYSTEM_ILLUSTRATION_CLEAR_DLS";
import SYSTEM_ILLUSTRATION_PROTECTION_DLS from "./assets/SYSTEM_ILLUSTRATION_PROTECTION_DLS";
import SYSTEM_ILLUSTRATION_INPROGRESS_DLS from "./assets/SYSTEM_ILLUSTRATION_INPROGRESS_DLS";
import ChevronBlueRight from "./assets/ChevronBlueRight";
import Thunder_green from "./assets/thunder_green";
import Currency_green from "./assets/currency_green";
import Trending_green from "./assets/trending_green";
import LoanRenewalLogo1 from "./assets/LoanRenewalLogo1";
import HeadSnapshot from './assets/HeadSnapshot';
import WorkAlert from './assets/WorkAlert';
import CapitalGainStatement from "./assets/capitalGain";
import CalendarArrow from './assets/CalendarArrow';
import PledgeMore from "./assets/PledgeMore";
import RemovePledge from "./assets/RemovePledge";
import HistoryBlue from "./assets/HistoryBlue";
import BajajFullLogoNew from "./assets/BajajFullLogoNew";
import NoPledges from "./assets/NoPledges";
import DocumentGreen from './assets/DocumentGreen';
import DownloadDocument from "./assets/downloadDocument";
import Home_borrower_lp from "./assets/Home_borrower_lp";
import Transaction_borrower_lp from './assets/transaction_borrower_lp';
import ManageLimit_borrower_lp from './assets/ManageLimit_borrower_lp';
import EmailVerifyMailIcon from './assets/EmailVerifyMailIcon';
import VERIFY_SMS_ICON from './assets/VERIFY_SMS_ICON';
import StepperInProgress from './assets/StepperInProgress';
import ShortfallBriefcase from './assets/ShortfallBriefcase';
import ShortFallRupee from './assets/ShortFallRupee';
import ContactIcon from "./assets/contactIcon";
import TransactionPlatform from "./assets/TransactionPlatform";
import InterestCalculator from './assets/InterestCalculator';
import PendingList from './assets/PendingList';
import InterestCalculatorDashboard from './assets/InterestCalculatorDashboard';
import LoanRenew from './assets/LoanRenew';
import WhatsAppOutline from "./assets/WhatsAppOutline";
import PendingAgreement from './assets/PendingAgreement';
import InterestRate from './assets/InterestRate';
import TenureDate from './assets/TenureDateIcon';
import WorkspacePremium from './assets/WorkspacePremium';
import Celebrations from './assets/Celebrations';
import Payments from './assets/Payments';
import RecieptLong from './assets/RecieptLong';
import RupeeBg from './assets/RupeeBg';
import TransactionFailed from './assets/TransactionFailed';
import SoftErrorIcon from './assets/SoftErrorIcon';
import DSPLogo from "./assets/DSPLogo";
import RedErrorIcon from "./assets/RedErrorIcon";
import MyLoanProfile from './assets/myLoanProfile';
import CongratulationsRipple from "./assets/CongratulationsRipple";
import FetchSuccess from "./assets/FetchSuccess";
import FetchSuccessImage from "./assets/FetchSuccessImage";
import Refresh from "./assets/Refresh";
import RightBlackArrow from "./assets/RightBlackArrow";
import FetchRupeeIcon from "./assets/FetchRupeeIcon";
import DeviceMobile from "./assets/DeviceMobile";
import MfdImage1 from "./assets/MfdImage1";
import HandCoins from "./assets/HandCoins";
import SecuredShield from "./assets/SecuredShield";
import CollateralIcon from './assets/CollateralIcon';
import DiscardLoan from './assets/DiscardLoan';
import Eyeslash from './assets/Eyeslash';
import FlashIcon from './assets/FlashIcon';
import FoldedHands from './assets/FoldedHands';
import MutualFundIcon from './assets/MutualFundIcon';
import OtherFeedbackIcon from './assets/OtherFeedbackIcon';
import PoorFeedbackIcon from './assets/PoorFeedback';
import PrepayLoan from './assets/PrepayLoan';
import CelebrationIcon from './assets/CelebrationIcon';
import EmergencyFundIcon from './assets/EmergencyFundIcon';
import MedicalIcon from './assets/MedicalIcon';
import FlightIcon from './assets/FlightIcon';
import CreditHealth from './assets/CreditHealth';
import ZeroCash from './assets/ZeroCash';
import CreditCash from './assets/CreditCash';
import SmilyFace from './assets/SmilyFace';
import CreditLineIcon from './assets/CreditLineIcon';
import InterstRateIcon from './assets/InterestRateIcon';
import MoneyIcon from './assets/MoneyIcon';
// @ts-ignore
export const iconTokensMap = {
    [IconTokens.Kfin]: Kfin,
    [IconTokens.Cdsl]: Cdsl,
    [IconTokens.Cams]: Cams,
    [IconTokens.PoweredBy]: Powerby,
    [IconTokens.Chat]: Chat,
    [IconTokens.Edit]: Edit,
    [IconTokens.Search]: Search,
    [IconTokens.Upload]: Upload,
    [IconTokens.Attachment]: Attachment,
    [IconTokens.Back]: Back,
    [IconTokens.PlusCircle]: PlusCircle,
    [IconTokens.Cross]: Cross,
    [IconTokens.CheckTwo]: Check2,
    [IconTokens.ThreeDots]: ThreeDots,
    [IconTokens.LocationPin]: LocationPin,
    [IconTokens.RightArrow]: RightArrow,
    [IconTokens.DownArrow]: DownArrow,
    [IconTokens.Quotes]: Quotes,
    [IconTokens.Plus]: Plus,
    [IconTokens.Shuffle]: Shuffle,
    [IconTokens.MinusCircle]: MinusCircle,
    [IconTokens.InfoStatic]: InfoStatic,
    [IconTokens.Calendar]: Calendar,
    [IconTokens.Cake]: Cake,
    [IconTokens.BriefCase]: BriefCase,
    [IconTokens.Book]: Book,
    [IconTokens.DoubleMessage]: DoubleMessage,
    [IconTokens.Info]: Info,
    [IconTokens.InfoFilled]: InfoFilled,
    [IconTokens.Lighting]: Lighting,
    [IconTokens.Notification]: Notification,
    [IconTokens.Play]: Play,
    [IconTokens.Download]: Download,
    [IconTokens.Mic]: Mic,
    [IconTokens.PDF]: PDF,
    [IconTokens.Gallery]: Gallery,
    [IconTokens.Video]: Video,
    [IconTokens.SendSolid]: SendSolid,
    [IconTokens.RightAngle]: RightAngle,
    [IconTokens.Fire]: Fire,
    [IconTokens.Newspaper]: NewsPaper,
    [IconTokens.Share]: Share,
    [IconTokens.Google]: Google,
    [IconTokens.Messages]: Messages,
    [IconTokens.Star]: Star,
    [IconTokens.Sparkling]: Sparkling,
    [IconTokens.Bookmark]: Bookmark,
    [IconTokens.BookmarkFilled]: BookmarkFilled,
    [IconTokens.Page]: Page,
    [IconTokens.Sticker]: Sticker,
    [IconTokens.TwoUsers]: TwoUsers,
    [IconTokens.Check]: Check,
    [IconTokens.Dot]: Dot,
    [IconTokens.BulbFilled]: BulbFilled,
    [IconTokens.BulbOutline]: BulbOutline,
    [IconTokens.CheckCircle]: CheckCircle,
    [IconTokens.Clock]: Clock,
    [IconTokens.Delete]: Delete,
    [IconTokens.AddUser]: AddUser,
    [IconTokens.UserClock]: UserClock,
    [IconTokens.Like]: Like,
    [IconTokens.LikeFilled]: LikeFilled,
    [IconTokens.Comment]: Comment,
    [IconTokens.Circle]: Circle,
    [IconTokens.StarOutline]: StarOutline,
    [IconTokens.Diamond]: Diamond,
    [IconTokens.Link]: Link,
    [IconTokens.Gift]: Gift,
    [IconTokens.CheckFilled]: CheckFilled,
    [IconTokens.InvertedComma]: InvertedComma,
    [IconTokens.CheckedSquare]: CheckedSquare,
    [IconTokens.NotCheckedSquare]: Not_Checked_Square,
    [IconTokens.Done]: Done,
    [IconTokens.Error]: Error,
    [IconTokens.Email]: Email,
    [IconTokens.Secure]: Secure,
    [IconTokens.RadioCircleFilled]: RadioCircleFilled,
    [IconTokens.SystemError]: SystemError,
    [IconTokens.EmptyCircle]: EmptyCircle,
    [IconTokens.Phone]: Phone,
    [IconTokens.CreditCard]: CreditCard,
    [IconTokens.Default]: Default,
    [IconTokens.Alert]: Alert,
    [IconTokens.Success]: Success,
    [IconTokens.InProgress]: InProgress,
    [IconTokens.Failed]: Failed,
    [IconTokens.Right]: Right,
    [IconTokens.ChevronDown]: ChevronDown,
    [IconTokens.Group46]: Group46,
    [IconTokens.InfoMessage]: InfoMessage,
    [IconTokens.Chart]: Chart,
    [IconTokens.RuppeFile]: RuppeFile,
    [IconTokens.Square]: Square,
    [IconTokens.GiftOutline]: GiftOutline,
    [IconTokens.InfoCropped]: InfoCropped,
    [IconTokens.Volt]: Volt,
    [IconTokens.Account]: Account,
    [IconTokens.Rectangle]: Rectangle,
    [IconTokens.Cancel]: Cancel,
    [IconTokens.ChervonDownRight]: ChervonDownRight,
    [IconTokens.Camera]: Camera,
    [IconTokens.CameraOff]: CameraOff,
    [IconTokens.Coin]: Coin,
    [IconTokens.SafeGuard]: SafeGuard,
    [IconTokens.Person]: Person,
    [IconTokens.Location]: Location,
    [IconTokens.Add]: Add,
    [IconTokens.Lock]: Lock,
    [IconTokens.Copy]: Copy,
    [IconTokens.GoogleSVG]: GoogleSVG,
    [IconTokens.OTPError]: OTPError,
    [IconTokens.DocFile]: DocFile,
    [IconTokens.Notebook]: Notebook,
    [IconTokens.ContractFile]: ContractFile,
    [IconTokens.FreeBook]: FreeBook,
    [IconTokens.HeadPhone]: HeadPhone,
    [IconTokens.Question]: Question,
    [IconTokens.Logout]: Logout,
    [IconTokens.User]: User,
    [IconTokens.Whatsapp]: Whatsapp,
    [IconTokens.Locked]: Locked,
    [IconTokens.ManageLimit]: ManageLimit,
    [IconTokens.Support]: Support,
    [IconTokens.File]: File,
    [IconTokens.VoltFull]: VoltFull,
    [IconTokens.Group74508]: Group74508,
    [IconTokens.RadioCircleNotFilled]: RadioCircleNotFilled,
    [IconTokens.TransactionNotSelected]: TransactionNotSelected,
    [IconTokens.NOTSELCTEDCHART]: NOTSELCTEDCHART,
    [IconTokens.Sound]: Sound,
    [IconTokens.ChevronLeft]: ChevronLeft,
    [IconTokens.GreenClipboard]: GreenClipBoard,
    [IconTokens.GreenRupee]: GreenRupee,
    [IconTokens.Telegram]: Telegram,
    [IconTokens.ThreeBar]: ThreeBar,
    [IconTokens.Nsdl]: Nsdl,
    [IconTokens.Bajaj]: Bajaj,
    [IconTokens.ThumpsUp]: ThumpsUp,
    [IconTokens.ShakeHands]: ShakeHands,
    [IconTokens.BellNotified]: BellNotified,
    [IconTokens.List]: List,
    [IconTokens.SvgChart]: SvgChart,
    [IconTokens.Redirecting]: Redirecting,
    [IconTokens.FAQ]: FAQ,
    [IconTokens.ShieldRuppee]: ShieldRuppee,
    [IconTokens.EditBlue]: EditBlue,
    [IconTokens.UpsideArrow]: UpsideArrow,
    [IconTokens.ManageLimitSelected]: ManageLimitSelected,
    [IconTokens.SMS]: SMS,
    [IconTokens.OTPEmail]: OTPEmail,
    [IconTokens.GreenXls]: GreenXls,
    [IconTokens.CoveredRightArrow]: CoveredRightArrow,
    [IconTokens.ChevronUp]: ChevronUp,
    [IconTokens.SystemSuccess]: SystemSuccess,
    [IconTokens.Leads]: Leads,
    [IconTokens.Grid_View]: GridView,
    [IconTokens.NoNetwork]: NoNetwork,
    [IconTokens.SuccessIcon]: SuccessIcon,
    [IconTokens.Pending]: Pending,
    [IconTokens.PendingRepay]: PendingRepay,
    [IconTokens.FailedNew]: FailedNew,
    [IconTokens.Warning]: Warning,
    [IconTokens.AutoPayArrow]: AutoPayArrow,
    [IconTokens.VoltPartner]: VoltPartner,
    [IconTokens.GoldenThunder]: GoldenThunder,
    [IconTokens.Brochure2]: Brochure2,
    [IconTokens.ADD_FRIEND]: AddFriend2,
    [IconTokens.Gift2]: Gift2,
    [IconTokens.Lead2]: Leads2,
    [IconTokens.ShareLink2]: ShareLink2,
    [IconTokens.Earning]: Earning,
    [IconTokens.Collateral]: Collateral,
    [IconTokens.DemoVideo]: DemoVideos,
    [IconTokens.ProfileDetails]: ProfileDetails,
    [IconTokens.BillingDetails]: BillingDetails,
    [IconTokens.Faq2]: Faq2,
    [IconTokens.AboutUs2]: AboutUs2,
    [IconTokens.AboutUs]: AboutUs,
    [IconTokens.AccountDetails]: AccountDetails,
    [IconTokens.Lead3]: Lead3,
    [IconTokens.Customer3]: Customer3,
    [IconTokens.Earning3]: Earning3,
    [IconTokens.Partner3]: Partner3,
    [IconTokens.Bijli]: Bijli,
    [IconTokens.Megaphone]: Megaphone,
    [IconTokens.Share4]: Share4,
    [IconTokens.TenToFiftyThousand]: TentoFiftyThousand,
    [IconTokens.FiftyToTwoLakh]: FiftyToTwoLakh,
    [IconTokens.TwoToTenLakh]: TwoToTenLakh,
    [IconTokens.MoreThanTenLakh]: MoreThanTenLakh,
    [IconTokens.NoMutualFund]: NoMutualFund,
    [IconTokens.NoMutualFundDefault]: NoMutualFundDefault,
    [IconTokens.NoMutualFundSelected]: NoMutualFundSelected,
    [IconTokens.YesMutualFundDefault]: YesMutualFundDefault,
    [IconTokens.YesMutualFundSelected]: YesMutualFundSelected,
    [IconTokens.SliderIcon]: SliderIcon,
    [IconTokens.LinkedPartners]: LinkedPartners,
    [IconTokens.VoltPlatform]: VoltPlatform,
    [IconTokens.SuccessIcon1]: SuccessIcon1,
    [IconTokens.VerifiedIcon1]: VerifiedUser1,
    [IconTokens.PasswordHide]: PasswordHide,
    [IconTokens.PasswordShow]: PasswordShow,
    [IconTokens.RightBlueArrow]: RightBlueArrow,
    [IconTokens.CrossIcon]: CrossIcon,
    [IconTokens.ErrorIcon]: ErrorIcon,
    [IconTokens.SystemWarning]: SystemWarning,
    [IconTokens.Check_Limit_1]: CheckLimit1,
    [IconTokens.Check_Limit_Grey]: CheckLimit_Grey,
    [IconTokens.Meter_1]: Meter1,
    [IconTokens.Percentage]: percentage,
    [IconTokens.InfoImage]: InfoImage,
    [IconTokens.SecureIcon]: SecureIcon,
    [IconTokens.InfoIcon]: InfoIcon,
    [IconTokens.Debit]: Debit,
    [IconTokens.Credit]: Credit,
    [IconTokens.DebitTdl]: DebitTdl,
    [IconTokens.CreditTdl]: CreditTdl,
    [IconTokens.TransactionSuccess]: transactionSuccess,
    [IconTokens.TransactionInProgress]: transactionInProgress,
    [IconTokens.DigioIcon]: DigiLocker,
    [IconTokens.ChevronUpV2]: chevronUp_V2,
    [IconTokens.ChevronDownV2]: chevronDown_V2,
    [IconTokens.LENDER_BAJAJ]: Lender_Bajaj,
    [IconTokens.LENDER_MIRAE]: Lender_Mirae,
    [IconTokens.LENDER_TATA]: Lender_Tata,
    [IconTokens.LENDER_NUVAMA]: Lender_Nuvama,
    [IconTokens.greenPercentage1]: greenPercentage1,
    [IconTokens.greenClock1]: greenClock1,
    [IconTokens.greenRupee1]: greenRupee1,
    [IconTokens.BackArrowIcon]: BackArrowIcon,
    [IconTokens.Pan1]: Pan1,
    [IconTokens.Verify_Aadhar1]: Veridy_aadhaar_1,
    [IconTokens.System_delete]: SystemDelete,
    [IconTokens.Verify_Bank1]: verifyAccountBank,
    [IconTokens.UpiIcon]: UpiIcon,
    [IconTokens.NetBanking]: NetBanking,
    [IconTokens.UpBlackArrow]: UpBlackArrow,
    [IconTokens.DownBlackArrow]: DownBlackArrow,
    [IconTokens.UpiInProgress]: UpiInProgress,
    [IconTokens.flash]: FlashComponent,
    [IconTokens.foreclosure]: Foreclosure,
    [IconTokens.RightBlackIcon]: RightBlackIcon,
    [IconTokens.LeftBlackArrowIcon]: LeftBlackArrowIcon,
    [IconTokens.SelectIcon]: SelectIcon,
    [IconTokens.ShareIcon]: ShareIcon,
    [IconTokens.AddPhoto]: AddPhoto,
    [IconTokens.MailIcon]: MailIcon,
    [IconTokens.CheckSms]: CheckSms,
    [IconTokens.Filter]: Filter,
    [IconTokens.UnSelectedRadioButton]: UnSelectedRadioButton,
    [IconTokens.APIFailureIcon]: APIFailureIcon,
    [IconTokens.ContactHeadphones]: ContactHeadphones,
    [IconTokens.InProgressGrey]: InProgressGrey,
    [IconTokens.VoltLogoNew]: VoltLogoNew,
    [IconTokens.MessageOtp]: MessageOtp,
    [IconTokens.Account_profile]: Account_profile,
    [IconTokens.Logout_Profile]: Logout_Profile,
    [IconTokens.AshokChakra]: AshokChakra,
    [IconTokens.IncomeTax]: IncomeTax,
    [IconTokens.ClockCheckLimit]: ClockCheckLimit,
    [IconTokens.Illustration]: Illustration,
    //DLS items
    [IconTokens.SYSTEM_STATUS_ERROR_DLS]: SYSTEM_STATUS_ERROR_DLS,
    [IconTokens.SYSTEM_STATUS_WARNING_DLS]: SYSTEM_STATUS_WARNING_DLS,
    [IconTokens.SYSTEM_STATUS_SUCCESS_DLS]: SYSTEM_STATUS_SUCCESS_DLS,
    [IconTokens.SYSTEM_STATUS_INFO_DLS]: SYSTEM_STATUS_INFO_DLS,
    [IconTokens.SYSTEM_STATUS_INFO_REDBG_DLS]: SYSTEM_STATUS_INFO_REDBG_DLS,
    [IconTokens.SYSTEM_SUCCESS_DLS]: SYSTEM_SUCCESS_DLS,
    [IconTokens.SYSTEM_CHEVRON_DOWN_DLS]: SYSTEM_CHEVRON_DOWN_DLS,
    [IconTokens.SYSTEM_ERROR_DLS]: SYSTEM_ERROR_DLS,
    [IconTokens.SYSTEM_MAIL_DLS]: SYSTEM_MAIL_DLS,
    [IconTokens.SYSTEM_CALL_DLS]: SYSTEM_CALL_DLS,
    [IconTokens.SYSTEM_CLOSE_W_CIRCLE_DLS]: SYSTEM_CLOSE_W_CIRCLE_DLS,
    [IconTokens.SYSTEM_CANCEL_DLS]: SYSTEM_CANCEL_DLS,
    [IconTokens.SYSTEM_EDIT_DLS]: SYSTEM_EDIT_DLS,
    [IconTokens.SYSTEM_PAN_CARD_DLS]: SYSTEM_PAN_CARD_DLS,
    [IconTokens.SYSTEM_BANK_DLS]: SYSTEM_BANK_DLS,
    [IconTokens.SYSTEM_SEARCH_DLS]: SYSTEM_SEARCH_DLS,
    [IconTokens.SYSTEM_ADD_DLS]: SYSTEM_ADD_DLS,
    [IconTokens.SYSTEM_UNLOCK_DLS]: SYSTEM_UNLOCK_DLS,
    [IconTokens.SYSTEM_INFO_DLS]: SYSTEM_INFO_DLS,
    [IconTokens.SYSTEM_FILTER_DLS]: SYSTEM_FILTER_DLS,
    [IconTokens.SYSTEM_BACK_DLS]: SYSTEM_BACK_DLS,
    [IconTokens.SYSTEM_PERSON_DLS]: SYSTEM_PERSON_DLS,
    [IconTokens.SYSTEM_LOCATION_DLS]: SYSTEM_LOCATION_DLS,
    [IconTokens.SYSTEM_CALENDAR_DLS]: SYSTEM_CALENDAR_DLS,
    [IconTokens.SYSTEM_DONE_DLS]: SYSTEM_DONE_DLS,
    [IconTokens.SYSTEM_SHARE_DLS]: SYSTEM_SHARE_DLS,
    [IconTokens.SYSTEM_NOTIFICATIONS_DLS]: SYSTEM_NOTIFICATIONS_DLS,
    [IconTokens.SYSTEM_NOTIFICATIONS_ACTIVE_DLS]: SYSTEM_NOTIFICATIONS_ACTIVE_DLS,
    [IconTokens.SYSTEM_EARLY_NUDGE_DLS]: SYSTEM_EARLY_NUDGE_DLS,
    [IconTokens.SYSTEM_LATER_NUDGE_DLS]: SYSTEM_LATER_NUDGE_DLS,
    [IconTokens.SYSTEM_COPY_DLS]: SYSTEM_COPY_DLS,
    [IconTokens.SYSTEM_SKIP_DLS]: SYSTEM_SKIP_DLS,
    [IconTokens.SYSTEM_CREDIT_DLS]: SYSTEM_CREDIT_DLS,
    [IconTokens.SYSTEM_DEBIT_DLS]: SYSTEM_DEBIT_DLS,
    [IconTokens.SYSTEM_FAQ_DLS]: SYSTEM_FAQ_DLS,
    [IconTokens.SYSTEM_SUPPORT_DLS]: SYSTEM_SUPPORT_DLS,
    [IconTokens.SYSTEM_TERMS_DLS]: SYSTEM_TERMS_DLS,
    [IconTokens.SYSTEM_POLICY_DLS]: SYSTEM_POLICY_DLS,
    [IconTokens.SYSTEM_LOGOUT_DLS]: SYSTEM_LOGOUT_DLS,
    [IconTokens.SYSTEM_MESSAGE_DLS]: SYSTEM_MESSAGE_DLS,
    [IconTokens.SYSTEM_FAQ_V2_DLS]: SYSTEM_FAQ_V2_DLS,
    [IconTokens.SYSTEM_RUPEE_DLS]: SYSTEM_RUPEE_DLS,
    [IconTokens.SYSTEM_LINK_DLS]: SYSTEM_LINK_DLS,
    [IconTokens.SYSTEM_INVESTOR_DLS]: SYSTEM_INVESTOR_DLS,
    [IconTokens.SYSTEM_PARTNER_DLS]: SYSTEM_PARTNER_DLS,
    [IconTokens.SYSTEM_WHATSAPP_DLS]: SYSTEM_WHATSAPP_DLS,
    [IconTokens.SYSTEM_TELEGRAM_DLS]: SYSTEM_TELEGRAM_DLS,
    [IconTokens.SYSTEM_MENU_DLS]: SYSTEM_MENU_DLS,
    [IconTokens.SYSTEM_SORT_DLS]: SYSTEM_SORT_DLS,
    [IconTokens.SYSTEM_EYE_DLS]: SYSTEM_EYE_DLS,
    [IconTokens.SYSTEM_EYE_HIDE_DLS]: SYSTEM_EYE_HIDE_DLS,
    [IconTokens.SYSTEM_DELETE_DLS]: SYSTEM_DELETE_DLS,
    [IconTokens.SYSTEM_CHEVRON_RIGHT_DLS]: SYSTEM_CHEVRON_RIGHT_DLS,
    [IconTokens.SYSTEM_CHEVRON_LEFT_DLS]: SYSTEM_CHEVRON_LEFT_DLS,
    [IconTokens.SYSTEM_AADHAR_DLS]: SYSTEM_AADHAR_DLS,
    [IconTokens.SYSTEM_PAN_V2_DLS]: SYSTEM_PAN_V2_DLS,
    [IconTokens.SYSTEM_LOAN_FORECLOSURE_DLS]: SYSTEM_LOAN_FORECLOSURE_DLS,
    [IconTokens.SYSTEM_LOAN_DLS]: SYSTEM_LOAN_DLS,
    [IconTokens.SYSTEM_DOWNLOAD_DOC_DLS]: SYSTEM_DOWNLOAD_DOC_DLS,
    [IconTokens.SYSTEM_REDIRECT_DLS]: SYSTEM_REDIRECT_DLS,
    [IconTokens.SYSTEM_CHEVRON_UP_DLS]: SYSTEM_CHEVRON_UP_DLS,
    [IconTokens.SYSTEM_ILLUSTRATION_DONE_DLS]: SYSTEM_ILLUSTRATION_DONE_DLS,
    [IconTokens.SYSTEM_ILLUSTRATION_ERROR_DLS]: SYSTEM_ILLUSTRATION_ERROR_DLS,
    [IconTokens.SYSTEM_ILLUSTRATION_CLEAR_DLS]: SYSTEM_ILLUSTRATION_CLEAR_DLS,
    [IconTokens.SYSTEM_ILLUSTRATION_PROTECTION_DLS]: SYSTEM_ILLUSTRATION_PROTECTION_DLS,
    [IconTokens.SYSTEM_ILLUSTRATION_INPROGRESS_DLS]: SYSTEM_ILLUSTRATION_INPROGRESS_DLS,
    [IconTokens.CHECKED_ROUNDED_DLS]: CHECKED_ROUNDED_DLS,
    [IconTokens.UNCHECK_ROUNDED_DLS]: UNCHECK_ROUNDED_DLS,
    [IconTokens.CHECK_SQUARE_DLS]: CHECK_SQUARE_DLS,
    [IconTokens.UNCHECK_SQUARE_DLS]: UNCHECK_SQUARE_DLS,
    [IconTokens.CHEVRON_BLUE_RIGHT]: ChevronBlueRight,
    [IconTokens.THUNDER_GREEN]: Thunder_green,
    [IconTokens.CURRENCY_GREEN]: Currency_green,
    [IconTokens.TRENDING_GREEN]: Trending_green,
    [IconTokens.LOAN_RENEWAL_1]: LoanRenewalLogo1,
    [IconTokens.HEAD_SNAPSHOT]: HeadSnapshot,
    [IconTokens.WORK_ALERT]: WorkAlert,
    [IconTokens.CAPITAL_GAIN_STATEMENT]: CapitalGainStatement,
    [IconTokens.CALENDAR_ARROW]: CalendarArrow,
    [IconTokens.PLEDGE_MORE]: PledgeMore,
    [IconTokens.REMOVE_PLEDGE]: RemovePledge,
    [IconTokens.HISTORY_BLUE]: HistoryBlue,
    [IconTokens.BAJAJ_FULL_LOGO_NEW]: BajajFullLogoNew,
    [IconTokens.NO_PLEDGES]: NoPledges,
    [IconTokens.DOCUMENT_GREEN]: DocumentGreen,
    [IconTokens.DOWNLOAD_DOCUMENT]: DownloadDocument,
    [IconTokens.HOME_BORROWER_LP]: Home_borrower_lp,
    [IconTokens.TRANSACTION_BORROWER_LP]: Transaction_borrower_lp,
    [IconTokens.MANAGE_LIMIT_BORROWER_LP]: ManageLimit_borrower_lp,
    [IconTokens.EMAIL_VERIFY_MAIL_ICON]: EmailVerifyMailIcon,
    [IconTokens.VERIFY_SMS_ICON]: VERIFY_SMS_ICON,
    [IconTokens.STEPPER_IN_PROGRESS]: StepperInProgress,
    [IconTokens.SHORTFALL_BRIEFCASE]: ShortfallBriefcase,
    [IconTokens.SHORTFALL_RUPEES]: ShortFallRupee,
    [IconTokens.CONTACT_ICON]: ContactIcon,
    [IconTokens.TRANSACTION_PLATFORM]: TransactionPlatform,
    [IconTokens.INTEREST_CALCULATOR]: InterestCalculator,
    [IconTokens.PENDING_LIST]: PendingList,
    [IconTokens.INTEREST_CALCULATOR_DASHBOARD]: InterestCalculatorDashboard,
    [IconTokens.LOAN_RENEW]: LoanRenew,
    [IconTokens.WHATSAPP_OUTLINE]: WhatsAppOutline,
    [IconTokens.PENDING_AGREEMENT]: PendingAgreement,
    [IconTokens.INTEREST_RATE]: InterestRate,
    [IconTokens.TENURE_DATE]: TenureDate,
    [IconTokens.WORKSPACE_PREMIUM]: WorkspacePremium,
    [IconTokens.CELEBRATION]: Celebrations,
    [IconTokens.PAYMENTS]: Payments,
    [IconTokens.RECIEPT_LONG]: RecieptLong,
    [IconTokens.RUPEE_BG]: RupeeBg,
    [IconTokens.TRANSACTION_FAILED]: TransactionFailed,
    [IconTokens.SOFT_ERROR_ICON]: SoftErrorIcon,
    [IconTokens.DSP_LOGO]: DSPLogo,
    [IconTokens.RED_ERROR_ICON]: RedErrorIcon,
    [IconTokens.MY_LOAN_PROFILE_ICON]: MyLoanProfile,
    [IconTokens.CONGRATULATIONS_RIPPLE]: CongratulationsRipple,
    [IconTokens.FETCH_SUCCESS]: FetchSuccess,
    [IconTokens.FETCH_SUCCESS_IMAGE]: FetchSuccessImage,
    [IconTokens.REFRESH]: Refresh,
    [IconTokens.RIGHT_BLACK_ARROW]: RightBlackArrow,
    [IconTokens.FETCH_RUPEE_ICON]: FetchRupeeIcon,
    [IconTokens.DEVICE_MOBILE]: DeviceMobile,
    [IconTokens.MFD_IMAGE_1]: MfdImage1,
    [IconTokens.HAND_COINS]: HandCoins,
    [IconTokens.SECURED_SHIELD]: SecuredShield,
    [IconTokens.COLLATERAL_ICON]: CollateralIcon,
    [IconTokens.PREPAY_LOAN_ICON]: PrepayLoan,
    [IconTokens.MUTUAL_FUNDS_ICON]: MutualFundIcon,
    [IconTokens.DISCARD_LOAN_ICON]: DiscardLoan,
    [IconTokens.POOR_EXPERIENCE_ICON]: PoorFeedbackIcon,
    [IconTokens.OTHER_FEEDBACK_ICON]: OtherFeedbackIcon,
    [IconTokens.EYESLASH_ICON]: Eyeslash,
    [IconTokens.FLASH_ICON]: FlashIcon,
    [IconTokens.FOLDED_HANDS_ICON]: FoldedHands,
    [IconTokens.EMERGENCY_FUNDS_ICON]: EmergencyFundIcon,
    [IconTokens.CELEBRATION_ICON]: CelebrationIcon,
    [IconTokens.FLIGHT_ICON]: FlightIcon,
    [IconTokens.MEDICAL_ICON]: MedicalIcon,
    [IconTokens.CREDIT_HEALTH]: CreditHealth,
    [IconTokens.CREDIT_CASH]: CreditCash,
    [IconTokens.ZERO_CASH]: ZeroCash,
    [IconTokens.SMILY_FACE]: SmilyFace,
    [IconTokens.CREDIT_LINE_ICON]: CreditLineIcon,
    [IconTokens.INTEREST_RATE_ICON]: InterstRateIcon,
    [IconTokens.MONEY_ICON]: MoneyIcon,
};
